import { useState } from 'react'

export const DEFAULT_ACTION_BAR_WIDTH = 60

const useActionBarWidth = () => {
  const [actionBarWidth, setActionBarWidth] = useState(DEFAULT_ACTION_BAR_WIDTH)

  return {
    actionBarWidth,
    setActionBarWidth,
  }
}

export default useActionBarWidth
